import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SuccessStatus() {
	return (
		<Box textAlign="center" py={4}>
			<Typography variant="h4" gutterBottom color="success.main">
				🎉 Welcome Aboard!
			</Typography>
			<Typography variant="h6" color="textSecondary" mb={3}>
				Your onboarding has been completed successfully.
			</Typography>
			<Typography variant="body1" color="textSecondary">
				You can now close this window. You'll receive further
				instructions via email.
			</Typography>
		</Box>
	);
}
